export default {
    cta: "问一个<br/>顾问",
    ordered: "订购日期 {date}"
}